import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import JwtService from "../common/jwt.service";
import { API_URL } from "../common/config";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
    },

    setHeader() {
        Vue.axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            "Authorization": `Bearer ${JwtService.getToken()}`
        };
    },

    setHeaderFile() {
        Vue.axios.defaults.headers.common = {
            // 'X-Requested-With': 'XMLHttpRequest',
            "Authorization": `Bearer ${JwtService.getToken()}`,
        };
    },

    get(resource, slug = "") {
        const url = slug ? resource + '/' + slug : resource
        return Vue.axios.get(url).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },

    postFile(resource, params) {
        this.setHeader();
        Vue.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
        return Vue.axios.post(`${resource}`, params);
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    delete(resource, slug = "") {
        const url = slug ? resource + '/' + slug : resource
        return Vue.axios.delete(url).catch(error => {
            throw new Error(`[DELETE] ApiService ${error}`);
        });
    },

    getFile(url) {
        return Vue.axios({
            url: url, //your url
            method: "GET",
            responseType: "blob", // important
        }).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },
};

export default ApiService;
